// @ts-nocheck

import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { fetchSubmissions } from '../../../actions/easygrader.action'
import PageNotFound from '../../../components/sis/PageNotFound'
import Submissions from '../../../components/sis/student/easygrader/Submissions'
import { selectSchool } from '../../../helpers/selectors'
import { isEmpty } from '../../../helpers/utils'
import withStudentDetails from '../../../hocs/withStudentDetailHOC'

function SubmissionsContainer({ fetchSubmissions }) {
  const { t } = useTranslation()
  const { tenant, id } = useParams()

  const [submissionDetails, setSubmissionDetails] = React.useState()

  const getSubmissionDetail = () => {
    fetchSubmissions(tenant, id, (data) => {
      setSubmissionDetails(data)
    })
  }

  const totalSimilarLines = useMemo(() => {
    const sum = submissionDetails?.plagiarism?.sources?.reduce((init, val) => {
      return init + val.similar_lines.length
    }, 0)
    return sum
  }, [submissionDetails])

  React.useEffect(() => {
    getSubmissionDetail()
  }, [])

  const allHeadCells = [
    {
      id: 'sno',
      label: t('sNo'),
      isSort: false,
      sortProperty: 'sno',
    },
    {
      id: 'sentences',
      label: t('sentences'),
      isSort: false,
      sortProperty: 'sentences',
    },
    {
      id: 'source',
      label: t('Sources'),
      isSort: false,
      sortProperty: 'source',
    },
  ]

  if (isEmpty(submissionDetails)) {
    return <PageNotFound />
  }

  return (
    <Submissions
      allHeadCells={allHeadCells}
      submissionDetails={submissionDetails}
      totalSimilarLines={totalSimilarLines}
    />
  )
}

SubmissionsContainer.propTypes = {
  fetchSubmissions: PropTypes.func,
  school: PropTypes.object,
}

SubmissionsContainer.defaultProps = {
  fetchSubmissions: () => {},
  school: {},
}
const mapStateToProps = (state) => ({
  school: selectSchool(state),
})

/**
 *  @exports connect function of redux
 */
export default withStudentDetails(
  connect(mapStateToProps, {
    fetchSubmissions,
  })(SubmissionsContainer)
)
